import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslate } from 'react-admin';

const useStyles = makeStyles({
  totalPercentage: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '25px',
    textAlign: 'center',
    verticalAlign: 'top',
    paddingTop: '8px !important',
  },

  limit: {
    opacity: '0',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '11px',
    textAlign: 'center',
  },

  errorLimit: {
    opacity: '1',
    color: 'red',
  },

  totalBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
  },
});

export const TotalPercentage = ({
  percentage,
  totalPercentage,
  errorMesage,
  limitMessage,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Box className={classes.totalBox}>
      <Typography
        className={`
        ${classes.totalPercentage}
        ${percentage && totalPercentage < 100 ? classes.errorLimit : ''}
        ${totalPercentage > 100 ? classes.errorLimit : ''}`}
      >
        {totalPercentage || 0}%
      </Typography>
      <Typography
        className={`
        ${classes.limit}
        ${
          totalPercentage > 100 || (percentage && totalPercentage < 100)
            ? classes.errorLimit
            : ''
        }`}
      >
        {percentage && totalPercentage < 100
          ? translate(errorMesage)
          : translate(limitMessage)}
      </Typography>
    </Box>
  );
};
